const types = {
  ALL_SERVICOS: "@servico/ALL",
  ADD_SERVICO: "@servico/ADD",
  UPDATE_SERVICO: "@servico/UPDATE",
  FILTER_SERVICO: "@servico/FILTER",
  RESET_SERVICO: "@servico/RESET",
  REMOVE_ARQUIVOS: "@servico/REMOVE_ARQUIVO",
  REMOVE_SERVICO: "@servico/REMOVE",
};

export default types;
